import { isArticle, phoneTrack, objId, piTaskId } from './card';
import { POINT_CONFIG } from '@shared/config';
import { useGlobalStore, useBusinessCardStore } from '@shared/store';
import { useRecord } from '@shared/hooks';

export const useMobile = () => {
  const globalStore = useGlobalStore();
  const cardStore = useBusinessCardStore();
  const { trackBuried } = useRecord();

  const clickMobile = (e: MouseEvent) => {
    if (isArticle.value) {
      phoneTrack.value = {
        ...phoneTrack.value,
        context: decodeURIComponent(phoneTrack.value?.context),
        optionType: POINT_CONFIG.OPERATION_TYPE.CALL,
        buriedPointType: POINT_CONFIG.BURIED_TYPE.BUSINESS,
        corpId: globalStore.appData.currentCorpId,
        source: phoneTrack.value?.source || POINT_CONFIG.SOURCE_ID.QT,
      };
      console.log('phoneTrack', phoneTrack);
      e.stopPropagation();
      trackBuried(phoneTrack)
        .then((res) => {
          console.log('文章详情页打电话埋点', res);
        })
        .catch((error) => {
          console.log('文章详情页打电话埋点error', error);
        });
    }
    try {
      _jt_.sendTracker({
        event_type: 'popup_window',
        block_desc: 'tel_page',
        button_desc: 'enter_btn',
        parameters: {
          objId: objId.value,
          pi_task_id: piTaskId,
        },
      });
    } catch (error) {
      console.log('%c  error:', 'color: #0e93e0;background: #aaefe5;', error);
    } finally {
      window.location.href = `tel:${cardStore.pageCardInfo.mobile}`;
    }
  };

  return {
    clickMobile,
  };
};
